import React from 'react';
import { Link } from 'react-router-dom';
import { track } from '../services/analytics';
export const Navigation = () => <><a className="skip-link" href="#main">Pular para conteúdo</a><nav aria-label="Principal" className="site-nav container"><Link className="brand" to="/">CoffeeIn Club</Link><div><Link to="/cafeterias" onClick={() => track('partner_cta_click', {
        placement: 'nav'
      })}>Para Cafeterias</Link><Link className="button" to="/app" state={{
        placement: "nav"
      }}>Baixar grátis</Link></div></nav></>;
